import atccSnapshotJson from '../constants/atcc-snapshot.json';
import { ArmoryItem, Gear, KratosTable, Titan, Weapon } from '../types/types';
import { mergeATCCItems, normalizeATCCItem } from './atcc-merge';

interface ATCCSnapshot {
    generatedAt: string;
    weapons: Weapon[];
    gear: Gear[];
    titans: Titan[];
    kratosTables: KratosTable[];
}

const atccSnapshot = atccSnapshotJson as ATCCSnapshot;

function sortByName<T extends ArmoryItem>(items: T[]): T[] {
    return items.slice().sort((a, b) => a.name.localeCompare(b.name));
}

export function mergeMissingDefaultItems<T extends ArmoryItem>(existingItems: T[], defaultItems: T[]): T[] {
    const itemMap = new Map<string, T>(existingItems.map((item) => [item.name, item]));

    for (const item of defaultItems) {
        if (!itemMap.has(item.name)) {
            itemMap.set(item.name, item);
        }
    }

    return sortByName(Array.from(itemMap.values()));
}

export function mergeBundledATCCItems<T extends ArmoryItem>(baseItems: T[], bundledItems: T[]): T[] {
    return sortByName(mergeATCCItems(baseItems, bundledItems) as T[]);
}

export function normalizeBundledATCCItems<T extends ArmoryItem>(items: T[]): T[] {
    return sortByName(items.map((item) => normalizeATCCItem(item)));
}

export function getBundledATCCSnapshot(): ATCCSnapshot {
    return atccSnapshot;
}

export function getDefaultArmoryData(baseData: { weapons: Weapon[]; gear: Gear[]; titans: Titan[]; kratosTables: KratosTable[] }) {
    return {
        weapons: mergeBundledATCCItems(baseData.weapons, atccSnapshot.weapons),
        gear: mergeBundledATCCItems(baseData.gear, atccSnapshot.gear),
        titans: mergeBundledATCCItems(baseData.titans, atccSnapshot.titans),
        kratosTables: mergeBundledATCCItems(baseData.kratosTables, atccSnapshot.kratosTables),
    };
}
